export default __webpack_public_path__ + "static/media/background.c3ba869e.png";